export enum SiteTreeSectionKeys {
  CODE_SAMPLES = "code-samples",
  CATEGORIES = "categories",
  GUIDES = "guides",
  LABS = "labs",
  CHALLENGES = "challenges",
  WORKSHOPS = "workshops",
  ARTICLES = "articles",
  WEBINARS = "webinars",
  STORIES = "stories",
  FULL_STACK = "full-stack",
  TEMPLATES = "templates"
}

export interface HubSiteTree {
  originUrl: string;
  root: {
    urlPath: string;
    id: string;
    displayName: string;
    sections: {
      codeSamples: {
        urlPath: string;
        id: string;
        displayName: string;
        sections: {
          fullStack: {
            urlPath: string;
            id: string;
            displayName: string;
          };
        };
      };
      guides: {
        urlPath: string;
        id: string;
        displayName: string;
      };
      labs: {
        urlPath: string;
        id: string;
        displayName: string;
      };
      templates: {
        urlPath: string;
        id: string;
        displayName: string;
      };
      challenges: {
        urlPath: string;
        id: string;
        displayName: string;
      };
      workshops: {
        urlPath: string;
        id: string;
        displayName: string;
      };
      articles: {
        urlPath: string;
        id: string;
        displayName: string;
      };
      webinars: {
        urlPath: string;
        id: string;
        displayName: string;
      };
      getStarted: {
        urlPath: string;
        id: string;
        displayName: string;
      };
      devDay: {
        urlPath: string;
        id: string;
        displayName: string;
      };
    };
  };
}

// TODO: Centralize the definition of this URL, document the impact on sitemap generation
export const hubOriginUrl = "https://developer.auth0.com";

export const hubSiteTree: HubSiteTree = {
  originUrl: hubOriginUrl,
  root: {
    urlPath: "resources",
    id: "root",
    displayName: "Resources",
    sections: {
      codeSamples: {
        id: "code-samples",
        urlPath: "code-samples",
        displayName: "Code Samples",
        sections: {
          fullStack: {
            id: "full-stack",
            urlPath: "full-stack",
            displayName: "Full Stack",
          },
        },
      },
      guides: {
        id: "guides",
        urlPath: "guides",
        displayName: "Guides",
      },
      labs: {
        id: "labs",
        urlPath: "labs",
        displayName: "Labs",
      },
      templates: {
        id: "templates",
        urlPath: "templates",
        displayName: "Templates",
      },
      challenges: {
        id: "challenges",
        urlPath: "challenges",
        displayName: "Challenges",
      },
      workshops: {
        id: "workshops",
        urlPath: "workshops",
        displayName: "Workshops",
      },
      articles: {
        id: "articles",
        urlPath: "articles",
        displayName: "Articles",
      },
      webinars: {
        id: "webinars",
        urlPath: "webinars",
        displayName: "Webinars",
      },
      getStarted: {
        id: "get-started",
        urlPath: "get-started",
        displayName: "Get Started",
      },
      devDay: {
        id: "challenges",
        urlPath: "challenges",
        displayName: "Challenges",
      },
    },
  },
};

export interface PortalSiteTree {
  root: {
    urlPath: string;
    id: string;
    displayName: string;
    sections: {
      guides: {
        urlPath: string;
        id: string;
        displayName: string;
      };
      codeSamples: {
        urlPath: string;
        id: string;
        displayName: string;
        sections: {};
      };
      content: {
        urlPath: string;
        id: string;
        displayName: string;
        sections: {
          drafts: {
            urlPath: string;
            id: string;
            displayName: string;
            sections: {
              draft: {
                urlPath: string;
                id: string;
                displayName: string;
              };
            };
          };
          templates: {
            urlPath: string;
            id: string;
            displayName: string;
          };
        };
      };
      tools: {
        urlPath: string;
        id: string;
        displayName: string;
        sections: {
          images: {
            urlPath: string;
            id: string;
            displayName: string;
            sections: {
              sectionCard: {
                urlPath: string;
                id: string;
                displayName: string;
              };
              documentCard: {
                urlPath: string;
                id: string;
                displayName: string;
              };
            };
          };
          repos: {
            urlPath: string;
            id: string;
            displayName: string;
            sections: {};
          };
          content: {
            urlPath: string;
            id: string;
            displayName: string;
            sections: {
              drafts: {
                urlPath: string;
                id: string;
                displayName: string;
                sections: {};
              };
              createDraft: {
                urlPath: string;
                id: string;
                displayName: string;
                sections: {};
              };
            };
          };
        };
      };
    };
  };
}

export const portalSiteTree: PortalSiteTree = {
  root: {
    urlPath: "",
    id: "root",
    displayName: "Auth0 R&D Portal",
    sections: {
      guides: {
        id: "guides",
        urlPath: "guides",
        displayName: "Guides",
      },
      codeSamples: {
        id: "code-samples",
        urlPath: "code-samples",
        displayName: "Code Samples",
        sections: {},
      },
      content: {
        id: "content",
        urlPath: "content",
        displayName: "Content",
        sections: {
          drafts: {
            id: "drafts",
            urlPath: "drafts",
            displayName: "Drafts",
            sections: {
              draft: {
                id: "draft",
                urlPath: "draft",
                displayName: "Draft",
              },
            },
          },
          templates: {
            id: "templates",
            urlPath: "templates",
            displayName: "Templates",
          },
        },
      },
      tools: {
        id: "tools",
        urlPath: "tools",
        displayName: "Hub Tools",
        sections: {
          repos: {
            id: "repos",
            urlPath: "repos",
            displayName: "Repo Tools",
            sections: {},
          },
          images: {
            id: "images",
            urlPath: "images",
            displayName: "Image Tools",
            sections: {
              sectionCard: {
                id: "section-card",
                urlPath: "section-card",
                displayName: "Section Card",
              },
              documentCard: {
                id: "document-card",
                urlPath: "document-card",
                displayName: "Document Card",
              },
            },
          },
          content: {
            id: "content",
            urlPath: "content",
            displayName: "Content",
            sections: {
              drafts: {
                id: "drafts",
                urlPath: "drafts",
                displayName: "Drafts",
                sections: {},
              },
              createDraft: {
                id: "create-draft",
                urlPath: "create-draft",
                displayName: "Create Draft",
                sections: {},
              },
            },
          },
        },
      },
    },
  },
};

export interface AuditSiteTree {
  root: {
    urlPath: string;
    id: string;
    displayName: string;
    sections: {
      categories: {
        urlPath: string;
        id: string;
        displayName: string;
      };
      codeSamples: {
        urlPath: string;
        id: string;
        displayName: string;
      };
      guides: {
        urlPath: string;
        id: string;
        displayName: string;
      };
    };
  };
}

export const auditSiteTree: AuditSiteTree = {
  root: {
    urlPath: "",
    id: "root",
    displayName: "Auth0 R&D Audit",
    sections: {
      codeSamples: {
        id: "code-samples",
        urlPath: "code-samples",
        displayName: "Code Samples",
      },
      categories: {
        id: "categories",
        urlPath: "categories",
        displayName: "Categories",
      },
      guides: {
        id: "guides",
        urlPath: "guides",
        displayName: "Guides",
      },
    },
  },
};

export interface ToolsSiteTree {
  root: {
    urlPath: string;
    id: string;
    displayName: string;
    sections: {
      images: {
        urlPath: string;
        id: string;
        displayName: string;
        sections: {
          sectionCard: {
            urlPath: string;
            id: string;
            displayName: string;
          };
          documentCard: {
            urlPath: string;
            id: string;
            displayName: string;
          };
        };
      };
    };
  };
}

export const toolsSiteTree: ToolsSiteTree = {
  root: {
    urlPath: "",
    id: "root",
    displayName: "Developer Hub Tools",
    sections: {
      images: {
        id: "images",
        urlPath: "images",
        displayName: "Image Tools",
        sections: {
          sectionCard: {
            id: "section-card",
            urlPath: "section-card",
            displayName: "Section Card",
          },
          documentCard: {
            id: "document-card",
            urlPath: "document-card",
            displayName: "Document Card",
          },
        },
      },
    },
  },
};
